import { styled } from 'styled-components';

export const Select = styled.select<{ $width?: string }>`
	padding: 6px;
	width: ${({ $width }) => ($width ? $width : '100%')};
	display: block;
	border-radius: 0.33rem;
	border: 1px solid #aaa;
	outline: 0;
`;
